import { ADDRESS_FIAS_LEVEL_SETTLEMENT } from '@sravni/cosago-react-library/lib/validationSchemes';

import type { TDadataFullAddressSelectOption } from 'shared/types';

const TERRITORY_ADDRESS_TYPES = ['тер', 'мкр', 'стр', 'г-к', 'пл-ка'];

/**
 * Проверяет, что адрес можно считать территорией, если:
 * - уровень ФИАС не ниже населённого пункта;
 * - тип улицы / населённого пункта входит в список территориальных обозначений.
 *
 * Примеры:
 * - street_type = "тер" -> true
 * - settlement_type = "мкр" -> true
 * - street_type = "ул", settlement_type = "г" -> false
 */
export const isAddressDataHasTerritory = (data: TDadataFullAddressSelectOption['data']) => {
  const { fias_level, street_type, settlement_type } = data;

  const isAllowedFiasLevel = Number(fias_level) >= ADDRESS_FIAS_LEVEL_SETTLEMENT;
  const hasTerritoryStreetType = TERRITORY_ADDRESS_TYPES.includes(street_type || '');
  const hasTerritorySettlementType = TERRITORY_ADDRESS_TYPES.includes(settlement_type || '');

  return isAllowedFiasLevel && (hasTerritoryStreetType || hasTerritorySettlementType);
};
